import React, { useState } from "react";
import { useQuery } from "@apollo/client";
import PropTypes from "prop-types";

import menuQuery from "./menu-query.graphql";
import RecursiveMenu from "./components/recursive-menu";
import classNames from "classnames";
import ErrorBoundary from "../../error-boundary";
import { useSelector } from "react-redux";

export const Menu = ({
  menuTree,
  menuName,
  showLabel = false,
  itemIcon,
  navClassName = "",
  ariaLabel,
}) => {
  const {
    data,
    loading = false,
    error = false,
  } = useQuery(menuQuery, {
    variables: { name: menuName },
    skip: menuTree?.links.length || !menuName,
  });

  const isMobile = useSelector((state) => state.appStore.isMobile);

  if (loading) {
    return false;
  }

  if (error) {
    return `Error! ${error.message}`;
  }

  const tree = menuTree || data.menuByName || [];

  if (!tree.links?.length) {
    return;
  }

  const isMainMenu = navClassName === "main-menu";
  const highlighted = isMainMenu
    ? tree.links.filter((item) => item.link.highlighted)
    : [];
  const standard = isMainMenu
    ? tree.links.filter((item) => !item.link.highlighted)
    : [];
  const treeLabel = showLabel && tree.label;

  return (
    <>
      <nav
        className={classNames({
          [tree.id]: tree.id,
          [navClassName]: !!navClassName,
        })}
        aria-label={ariaLabel}
      >
        <ErrorBoundary>
          {isMainMenu && !isMobile ? (
            <>
              {highlighted.length > 0 && (
                <RecursiveMenu
                  items={highlighted}
                  itemIcon={itemIcon}
                  treeLabel={treeLabel}
                  isMainMenu
                />
              )}
              {standard.length > 0 && (
                <RecursiveMenu
                  items={standard}
                  itemIcon={itemIcon}
                  treeLabel={treeLabel}
                  isMainMenu
                />
              )}
            </>
          ) : (
            <RecursiveMenu
              items={tree.links}
              itemIcon={itemIcon}
              treeLabel={treeLabel}
              isMainMenu
            />
          )}
        </ErrorBoundary>
      </nav>
    </>
  );
};

const menuItemPropTypes = {
  link: PropTypes.shape({
    label: PropTypes.string,
    url: PropTypes.shape({
      path: PropTypes.string,
    }),
  }),
  //subTree: PropTypes.arrayOf(PropTypes.shape(menuItemPropTypes)),
};

Menu.propTypes = {
  /* Previously fetched Menu */
  menuTree: PropTypes.shape({
    label: PropTypes.string,
    links: PropTypes.arrayOf(PropTypes.shape(menuItemPropTypes)),
  }),
  /* Menu to fetch */
  menuName: PropTypes.string,
  showLabel: PropTypes.bool,
  itemOnClickHandler: PropTypes.func,
  itemClassName: PropTypes.string,
  itemIcon: PropTypes.element,
  listClassName: PropTypes.string,
  navClassName: PropTypes.string,
  ariaLabel: PropTypes.string.isRequired,
};
